import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Supports child elements of type `h1`, `h2` and `p` */
@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopComponent {
  @Input() showStartLink = true;
}
